import { useGetList } from 'react-admin';

// Stage ids are per tenant, so nothing may hardcode one. The endpoint is
// already tenant scoped and ordered, so the first row is this tenant's default.
export const useOpportunityStages = () => {
  const { data: stages = [] } = useGetList('opportunity-stages', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'order', order: 'ASC' }
  });

  return { stages, firstStageId: stages[0]?.id as number | undefined };
};
